import { fontFamilies } from '@/src/common/theme'
import { Text } from 'react-native'

export function CardBenefitsComponentsOfferIsNowFull({ ctaAction }: { ctaAction: string }) {
  return ctaAction === 'enrollment_full' ? (
    <Text
      style={{ fontSize: 14, fontFamily: fontFamilies['PlusJakartaSans-Bold'], fontWeight: 700 }}
    >
      This Offer Is Now Full{'\n\n'}
    </Text>
  ) : null
}
